var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { attrs: { id: "tab-sub-bill" } },
        [
          _c("div", { staticClass: "section operations" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cooperateEdit,
                    expression: "cooperateEdit"
                  }
                ],
                staticClass: "triggers"
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "el-dropdown",
                      {
                        class: _vm.readonly ? "not-click" : "",
                        attrs: { no: "1", "split-button": "", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.commandHandle(_vm.command1)
                          },
                          command: function(p) {
                            _vm.command1 = p
                            _vm.commandHandle(_vm.command1)
                          }
                        }
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.command1) + " "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t("SeaExport.CodeSearching")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CodeSearching"))
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t(
                                    "SeaExport.CopyFromTheLastTime"
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.CopyFromTheLastTime")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t("SeaExport.CopyFromOtherBill")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CopyFromOtherBill"))
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t(
                                    "SeaExport.CopyCargoDescriptionAndMarks"
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SeaExport.CopyCargoDescriptionAndMarks"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: Boolean(_vm.form.uuid),
                            expression: "Boolean(form.uuid)"
                          }
                        ],
                        attrs: {
                          no: "2",
                          disabled: _vm.btnPrintDisabled,
                          type: "primary"
                        },
                        on: { click: _vm.originalPrint }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.form.releaseType === 1
                              ? _vm.$t("SeaExport.PrintTheOriginalBl")
                              : _vm.$t("SeaExport.TelexRelease")
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.readonly && Boolean(_vm.form.uuid),
                            expression: "readonly && Boolean(form.uuid)"
                          },
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["button_M/HBL_confirmBL"],
                            expression: "['button_M/HBL_confirmBL']"
                          }
                        ],
                        attrs: { no: "ConfirmChecking", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.pm.confirmBL()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.ConfirmChecking")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.readonly && _vm.form.state == 2,
                            expression: "readonly&&form.state==2"
                          }
                        ],
                        attrs: { no: "3", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.pm.onState()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Unlock")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.readonly && Boolean(_vm.form.uuid),
                            expression: "readonly && Boolean(form.uuid)"
                          },
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["button_M/HBL_identification"],
                            expression: "['button_M/HBL_identification']"
                          }
                        ],
                        attrs: { no: "IdentificationList", type: "primary" },
                        on: { click: _vm.onIdentificationList }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.IdentificationList")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { value: _vm.form.state === 2, disabled: true }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Locked")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "4", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.oversea,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "oversea", $$v)
                          },
                          expression: "form.oversea"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.BlBeReleased")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "5", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.manifestEDI,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "manifestEDI", $$v)
                          },
                          expression: "form.manifestEDI"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.ManifestEdi")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "6", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.printParam1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "printParam1", $$v)
                          },
                          expression: "form.printParam1"
                        }
                      },
                      [_vm._v("Part of")]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "7", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.printParam2,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "printParam2", $$v)
                          },
                          expression: "form.printParam2"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SeaExport.ClauseOfNoWoodPackingMaterial")
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "8", disabled: _vm.readonly },
                        on: {
                          change: function(val) {
                            _vm.pm.chargeContainer()
                          }
                        },
                        model: {
                          value: _vm.form.printParam3,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "printParam3", $$v)
                          },
                          expression: "form.printParam3"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "SeaExport.ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS"
                            )
                          )
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ]),
          _c(
            "tab-sub-bill-UICustom-layout",
            {
              attrs: {
                "element-blocks": _vm.elementBlocks,
                disabled: _vm.readonly
              }
            },
            [
              _vm.elementDict.shipper.viewable
                ? _c(
                    "template",
                    { slot: "shipper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("line-label", {
                                class: _vm.elementDict.shipper.isRequire
                                  ? "blue "
                                  : "",
                                attrs: { label: _vm.elementDict.shipper.label }
                              }),
                              _c("char-count", {
                                staticStyle: {
                                  position: "static",
                                  display: "block",
                                  "font-size": "10px",
                                  color: "#909399"
                                },
                                attrs: { form: _vm.form, prefix: "shipper" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                staticStyle: { flex: "1", width: "129px" },
                                attrs: {
                                  disabled: !_vm.elementDict.shipper.writable,
                                  no: "9"
                                },
                                model: {
                                  value: _vm.form.shipperCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "shipperCode", $$v)
                                  },
                                  expression: "form.shipperCode"
                                }
                              }),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "6px" },
                                  attrs: {
                                    no: "10",
                                    disabled: !_vm.elementDict.shipper.writable,
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.onClear(1)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                              )
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.shipper.writable,
                              no: "11",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function($event) {
                                return _vm.CargoDocUtil.sftAddrChangeWrap(
                                  "shipperLine1",
                                  "shipperLine2",
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showShipperDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.shipperLine1,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shipperLine1", $$v)
                              },
                              expression: "form.shipperLine1"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.shipper.writable,
                              no: "12",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function($event) {
                                return _vm.CargoDocUtil.sftAddrChangeWrap(
                                  "shipperLine2",
                                  "shipperLine3",
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showShipperDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.shipperLine2,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shipperLine2", $$v)
                              },
                              expression: "form.shipperLine2"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.shipper.writable,
                              no: "13",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function($event) {
                                return _vm.CargoDocUtil.sftAddrChangeWrap(
                                  "shipperLine3",
                                  "shipperLine4",
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showShipperDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.shipperLine3,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shipperLine3", $$v)
                              },
                              expression: "form.shipperLine3"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.shipper.writable,
                              no: "14",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function($event) {
                                return _vm.CargoDocUtil.sftAddrChangeWrap(
                                  "shipperLine4",
                                  "shipperLine5",
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showShipperDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.shipperLine4,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shipperLine4", $$v)
                              },
                              expression: "form.shipperLine4"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.shipper.writable,
                              no: "15",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function($event) {
                                return _vm.CargoDocUtil.sftAddrChangeWrap(
                                  "shipperLine5",
                                  "shipperLine6",
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showShipperDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.shipperLine5,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shipperLine5", $$v)
                              },
                              expression: "form.shipperLine5"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.shipper.writable,
                              no: "16",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showShipperDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.shipperLine6,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shipperLine6", $$v)
                              },
                              expression: "form.shipperLine6"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.shipper.writable,
                              no: "160",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showShipperDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.shipperLine7,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shipperLine7", $$v)
                              },
                              expression: "form.shipperLine7"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.consignee.viewable
                ? _c(
                    "template",
                    { slot: "consignee" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("line-label", {
                                class: _vm.elementDict.consignee.isRequire
                                  ? "blue "
                                  : "",
                                attrs: {
                                  label: _vm.elementDict.consignee.label
                                }
                              }),
                              _c("char-count", {
                                staticStyle: {
                                  position: "static",
                                  display: "block",
                                  "font-size": "10px",
                                  color: "#909399"
                                },
                                attrs: { form: _vm.form, prefix: "consignee" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  disabled: !_vm.elementDict.consignee.writable,
                                  no: "17"
                                },
                                model: {
                                  value: _vm.form.consigneeCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "consigneeCode", $$v)
                                  },
                                  expression: "form.consigneeCode"
                                }
                              }),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "6px" },
                                  attrs: {
                                    no: "18",
                                    disabled: !_vm.elementDict.consignee
                                      .writable,
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.onClear(2)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                              )
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.consignee.writable,
                              no: "19",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function($event) {
                                return _vm.CargoDocUtil.sftAddrChangeWrap(
                                  "consigneeLine1",
                                  "consigneeLine2",
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showConsigneeDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.consigneeLine1,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "consigneeLine1", $$v)
                              },
                              expression: "form.consigneeLine1"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.consignee.writable,
                              no: "20",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function($event) {
                                return _vm.CargoDocUtil.sftAddrChangeWrap(
                                  "consigneeLine2",
                                  "consigneeLine3",
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showConsigneeDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.consigneeLine2,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "consigneeLine2", $$v)
                              },
                              expression: "form.consigneeLine2"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.consignee.writable,
                              no: "21",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function($event) {
                                return _vm.CargoDocUtil.sftAddrChangeWrap(
                                  "consigneeLine3",
                                  "consigneeLine4",
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showConsigneeDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.consigneeLine3,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "consigneeLine3", $$v)
                              },
                              expression: "form.consigneeLine3"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.consignee.writable,
                              no: "22",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function($event) {
                                return _vm.CargoDocUtil.sftAddrChangeWrap(
                                  "consigneeLine4",
                                  "consigneeLine5",
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showConsigneeDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.consigneeLine4,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "consigneeLine4", $$v)
                              },
                              expression: "form.consigneeLine4"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.consignee.writable,
                              no: "23",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function($event) {
                                return _vm.CargoDocUtil.sftAddrChangeWrap(
                                  "consigneeLine5",
                                  "consigneeLine6",
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showConsigneeDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.consigneeLine5,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "consigneeLine5", $$v)
                              },
                              expression: "form.consigneeLine5"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.consignee.writable,
                              no: "24",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showConsigneeDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.consigneeLine6,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "consigneeLine6", $$v)
                              },
                              expression: "form.consigneeLine6"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.consignee.writable,
                              no: "240",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showConsigneeDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.consigneeLine7,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "consigneeLine7", $$v)
                              },
                              expression: "form.consigneeLine7"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.notify.viewable
                ? _c(
                    "template",
                    { slot: "notify" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("line-label", {
                                class: _vm.elementDict.notify.isRequire
                                  ? "blue "
                                  : "",
                                attrs: { label: _vm.elementDict.notify.label }
                              }),
                              _c("char-count", {
                                staticStyle: {
                                  position: "static",
                                  display: "block",
                                  "font-size": "10px",
                                  color: "#909399"
                                },
                                attrs: { form: _vm.form, prefix: "notify" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  disabled: !_vm.elementDict.notify.writable,
                                  no: "25"
                                },
                                model: {
                                  value: _vm.form.notifyCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "notifyCode", $$v)
                                  },
                                  expression: "form.notifyCode"
                                }
                              }),
                              _c(
                                "div",
                                { staticStyle: { "margin-top": "5px" } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        no: "26",
                                        disabled: !_vm.elementDict.notify
                                          .writable,
                                        type: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.pm.onClear(3)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-left": "6px" },
                                      attrs: {
                                        no: "27",
                                        disabled: !_vm.elementDict.notify
                                          .writable,
                                        type: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.pm.onCopy_consignee()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.CopyTheConsignee")
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.notify.writable,
                              no: "28",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function($event) {
                                return _vm.CargoDocUtil.sftAddrChangeWrap(
                                  "notifyLine1",
                                  "notifyLine2",
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showNotifyDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.notifyLine1,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "notifyLine1", $$v)
                              },
                              expression: "form.notifyLine1"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.notify.writable,
                              no: "29",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function($event) {
                                return _vm.CargoDocUtil.sftAddrChangeWrap(
                                  "notifyLine2",
                                  "notifyLine3",
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showNotifyDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.notifyLine2,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "notifyLine2", $$v)
                              },
                              expression: "form.notifyLine2"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.notify.writable,
                              no: "30",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function($event) {
                                return _vm.CargoDocUtil.sftAddrChangeWrap(
                                  "notifyLine3",
                                  "notifyLine4",
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showNotifyDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.notifyLine3,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "notifyLine3", $$v)
                              },
                              expression: "form.notifyLine3"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.notify.writable,
                              no: "31",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function($event) {
                                return _vm.CargoDocUtil.sftAddrChangeWrap(
                                  "notifyLine4",
                                  "notifyLine5",
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showNotifyDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.notifyLine4,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "notifyLine4", $$v)
                              },
                              expression: "form.notifyLine4"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.notify.writable,
                              no: "32",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function($event) {
                                return _vm.CargoDocUtil.sftAddrChangeWrap(
                                  "notifyLine5",
                                  "notifyLine6",
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showNotifyDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.notifyLine5,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "notifyLine5", $$v)
                              },
                              expression: "form.notifyLine5"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.notify.writable,
                              no: "33",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showNotifyDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.notifyLine6,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "notifyLine6", $$v)
                              },
                              expression: "form.notifyLine6"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.notify.writable,
                              no: "330",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showNotifyDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.notifyLine7,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "notifyLine7", $$v)
                              },
                              expression: "form.notifyLine7"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.agentParty.viewable
                ? _c(
                    "template",
                    { slot: "agentParty" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.agentParty.isRequire
                              ? "blue "
                              : "",
                            staticStyle: { color: "#404144" },
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.agentParty.label
                            },
                            slot: "label"
                          }),
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  flex: "1",
                                  "text-align": "right"
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "6px" },
                                    attrs: { no: "34", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onClear(4)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                                ),
                                _c(
                                  "el-dropdown",
                                  {
                                    class:
                                      _vm.readonly ||
                                      !_vm.elementDict.agentParty.writable
                                        ? "not-click"
                                        : "",
                                    staticStyle: {
                                      "margin-left": "6px",
                                      "vertical-align": "bottom"
                                    },
                                    attrs: {
                                      no: "35",
                                      "split-button": "",
                                      type: "primary"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.commandHandle(_vm.command3)
                                      },
                                      command: function(p) {
                                        _vm.command3 = p
                                        _vm.commandHandle(_vm.command3)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(" " + _vm._s(_vm.command3) + " "),
                                    _c(
                                      "el-dropdown-menu",
                                      {
                                        attrs: { slot: "dropdown" },
                                        slot: "dropdown"
                                      },
                                      [
                                        _c(
                                          "el-dropdown-item",
                                          {
                                            attrs: {
                                              command: _vm.$t(
                                                "SeaExport.CopyMblConsignee"
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "SeaExport.CopyMblConsignee"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-dropdown-item",
                                          {
                                            attrs: {
                                              command: _vm.$t(
                                                "SeaExport.CopyNominatedAgentInfo"
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "SeaExport.CopyNominatedAgentInfo"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.agentParty.writable,
                              no: "36",
                              "auto-uppercase": _vm.isUppercase
                            },
                            on: {
                              change: function($event) {
                                return _vm.CargoDocUtil.sftAddrChangeWrap(
                                  "agentPartyLine1",
                                  "agentPartyLine2",
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showAgentPartyDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.agentPartyLine1,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "agentPartyLine1", $$v)
                              },
                              expression: "form.agentPartyLine1"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.agentParty.writable,
                              no: "37",
                              "auto-uppercase": _vm.isUppercase
                            },
                            on: {
                              change: function($event) {
                                return _vm.CargoDocUtil.sftAddrChangeWrap(
                                  "agentPartyLine2",
                                  "agentPartyLine3",
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showAgentPartyDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.agentPartyLine2,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "agentPartyLine2", $$v)
                              },
                              expression: "form.agentPartyLine2"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.agentParty.writable,
                              no: "38",
                              "auto-uppercase": _vm.isUppercase
                            },
                            on: {
                              change: function($event) {
                                return _vm.CargoDocUtil.sftAddrChangeWrap(
                                  "agentPartyLine3",
                                  "agentPartyLine4",
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showAgentPartyDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.agentPartyLine3,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "agentPartyLine3", $$v)
                              },
                              expression: "form.agentPartyLine3"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.agentParty.writable,
                              no: "39",
                              "auto-uppercase": _vm.isUppercase
                            },
                            on: {
                              change: function($event) {
                                return _vm.CargoDocUtil.sftAddrChangeWrap(
                                  "agentPartyLine4",
                                  "agentPartyLine5",
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showAgentPartyDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.agentPartyLine4,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "agentPartyLine4", $$v)
                              },
                              expression: "form.agentPartyLine4"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.agentParty.writable,
                              no: "40",
                              "auto-uppercase": _vm.isUppercase
                            },
                            on: {
                              change: function($event) {
                                return _vm.CargoDocUtil.sftAddrChangeWrap(
                                  "agentPartyLine5",
                                  "agentPartyLine6",
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showAgentPartyDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.agentPartyLine5,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "agentPartyLine5", $$v)
                              },
                              expression: "form.agentPartyLine5"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.agentParty.writable,
                              no: "41",
                              "auto-uppercase": _vm.isUppercase
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showAgentPartyDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.agentPartyLine6,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "agentPartyLine6", $$v)
                              },
                              expression: "form.agentPartyLine6"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("cargo-input", {
                            attrs: {
                              disabled: !_vm.elementDict.agentParty.writable,
                              no: "410",
                              "auto-uppercase": _vm.isUppercase
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showAgentPartyDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form.agentPartyLine7,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "agentPartyLine7", $$v)
                              },
                              expression: "form.agentPartyLine7"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.quantity.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "quantity" }, slot: "quantity" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.quantity.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.quantity.label
                        },
                        slot: "label"
                      }),
                      _c("auto-number-input", {
                        attrs: {
                          disabled: !_vm.elementDict.quantity.writable,
                          no: "42",
                          precision: 0,
                          min: 0
                        },
                        on: { change: _vm.hblNbr2Change },
                        model: {
                          value: _vm.form.quantity,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "quantity", $$v)
                          },
                          expression: "form.quantity"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.packing.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "packing" }, slot: "packing" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.packing.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.packing.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-packing-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "default-value": _vm.form.packing,
                          disabled: !_vm.elementDict.packing.writable,
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.form.packing = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.packingName.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "packingName" }, slot: "packingName" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.packingName.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.packingName.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.packingName.writable
                        },
                        model: {
                          value: _vm.form.packingName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "packingName", $$v)
                          },
                          expression: "form.packingName"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.insideQuantity.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "insideQuantity" },
                      slot: "insideQuantity"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.insideQuantity.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.insideQuantity.label
                        },
                        slot: "label"
                      }),
                      _c("auto-number-input", {
                        attrs: {
                          disabled: !_vm.elementDict.insideQuantity.writable,
                          precision: 0,
                          min: 0
                        },
                        on: { change: _vm.hblNbr2Change },
                        model: {
                          value: _vm.form.insideQuantity,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "insideQuantity", $$v)
                          },
                          expression: "form.insideQuantity"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.weight.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "weight" }, slot: "weight" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.weight.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.weight.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { flex: "1" },
                            attrs: {
                              disabled: !_vm.elementDict.weight.writable,
                              precision: 3,
                              controls: false
                            },
                            on: { change: _vm.hblNbr2Change },
                            model: {
                              value: _vm.form.weight,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "weight", $$v)
                              },
                              expression: "form.weight"
                            }
                          }),
                          _c("span", [_vm._v("KGS")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cubage.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "cubage" }, slot: "cubage" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cubage.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cubage.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { flex: "1" },
                            attrs: {
                              disabled: !_vm.elementDict.cubage.writable,
                              precision: 3,
                              controls: false
                            },
                            on: { change: _vm.hblNbr2Change },
                            model: {
                              value: _vm.form.cubage,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cubage", $$v)
                              },
                              expression: "form.cubage"
                            }
                          }),
                          _c("span", [_vm._v("CBM")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cargoEnglishName.viewable
                ? _c(
                    "template",
                    { slot: "cargoEnglishName" },
                    [
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.isEdit &&
                                _vm.elementDict.cargoEnglishName.writable,
                              expression:
                                "isEdit && elementDict.cargoEnglishName.writable"
                            }
                          ],
                          staticClass: "auto-width"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { float: "right" },
                                  attrs: { no: "43", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.getMBLInfo("EName")
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SeaExport.CopyEnglishDescriptionOfGoodsFromMbl"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.cargoEnglishName.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.cargoEnglishName.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-rich-textarea", {
                            staticStyle: { height: "110px" },
                            attrs: {
                              "show-count": true,
                              no: "44",
                              disabled:
                                !_vm.isEdit ||
                                !_vm.elementDict.cargoEnglishName.writable,
                              "text-chars": 0,
                              "warning-count": -1,
                              "wrap-symbol": "r",
                              "auto-uppercase": _vm.isUppercaseByConfig,
                              "auto-half-word": ""
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                                  _vm.form.cargoEnglishName,
                                  function(val) {
                                    _vm.form.cargoEnglishName = val
                                  },
                                  _vm.isUppercaseByConfig,
                                  { autoHalfWord: true, autoUppercase: true }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.cargoEnglishName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cargoEnglishName", $$v)
                              },
                              expression: "form.cargoEnglishName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.mark.viewable
                ? _c(
                    "template",
                    { slot: "mark" },
                    [
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.isEdit && _vm.elementDict.mark.writable,
                              expression: "isEdit && elementDict.mark.writable"
                            }
                          ],
                          staticClass: "auto-width"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    float: "right",
                                    "margin-left": "5px"
                                  },
                                  attrs: { no: "45", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.getMBLInfo("mark")
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.CopyMarksFromMbl"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "auto-width" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.mark.isRequire ? "blue" : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.mark.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-rich-textarea", {
                            staticStyle: { height: "110px" },
                            attrs: {
                              "show-count": true,
                              no: "46",
                              "text-chars": 0,
                              "warning-count": -1,
                              "wrap-symbol": "r",
                              "auto-uppercase": _vm.isUppercaseByConfig,
                              "auto-half-word": "",
                              disabled:
                                !_vm.isEdit || !_vm.elementDict.mark.writable
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.Marks"),
                                  _vm.form.mark,
                                  function(val) {
                                    _vm.form.mark = val
                                  },
                                  _vm.isUppercaseByConfig,
                                  { autoHalfWord: true, autoUppercase: true }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.mark,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mark", $$v)
                              },
                              expression: "form.mark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.txtQuantitySum.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { slot: "txtQuantitySum" },
                      slot: "txtQuantitySum"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.txtQuantitySum.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.txtQuantitySum.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { disabled: true, value: _vm.txtQuantitySum }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.hblNbr2.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "hblNbr2" }, slot: "hblNbr2" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.hblNbr2.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.hblNbr2.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.hblNbr2.writable,
                          no: "47"
                        },
                        on: { input: _vm.hblNbr2Change },
                        model: {
                          value: _vm.form.hblNbr2,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "hblNbr2", $$v)
                          },
                          expression: "form.hblNbr2"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.serialNo.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "serialNo" }, slot: "serialNo" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.serialNo.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.serialNo.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.serialNo.writable,
                          no: "48"
                        },
                        model: {
                          value: _vm.form.serialNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "serialNo", $$v)
                          },
                          expression: "form.serialNo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.txtFirstVesselVoyage.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "txtFirstVesselVoyage" },
                      slot: "txtFirstVesselVoyage"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.txtFirstVesselVoyage.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.txtFirstVesselVoyage.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: true,
                          value: _vm.txtFirstVesselVoyage
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.etd.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "etd" }, slot: "etd" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.etd.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.etd.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          value: _vm.moment(_vm.job.etd).format("YYYY-MM-DD"),
                          disabled: true
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.dispatchingPlaceCode.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "dispatchingPlaceCode" },
                      slot: "dispatchingPlaceCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.dispatchingPlaceCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.dispatchingPlaceCode.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: true,
                          "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.form.dispatchingPlaceCode || "",
                          "tag-name": "englishName"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.portChange(p, "dispatchingPlace")
                          }
                        }
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.dispatchingPlaceCode
                            .writable,
                          no: "49"
                        },
                        model: {
                          value: _vm.form.dispatchingPlace,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "dispatchingPlace", $$v)
                          },
                          expression: "form.dispatchingPlace"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.loadingPortCode.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "loadingPortCode" },
                      slot: "loadingPortCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.loadingPortCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.loadingPortCode.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: true,
                          "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.form.loadingPortCode || "",
                          "tag-name": "englishName",
                          no: "loadingPortCode"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.portChange(p, "loadingPort")
                          }
                        }
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.loadingPortCode.writable,
                          no: "50"
                        },
                        model: {
                          value: _vm.form.loadingPort,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "loadingPort", $$v)
                          },
                          expression: "form.loadingPort"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.dischargingPortCode.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "dischargingPortCode" },
                      slot: "dischargingPortCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.dischargingPortCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.dischargingPortCode.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: true,
                          "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.form.dischargingPortCode || "",
                          "tag-name": "englishName",
                          no: "dischargingPortCode"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.portChange(p, "dischargingPort")
                          }
                        }
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.dischargingPortCode
                            .writable,
                          no: "51"
                        },
                        model: {
                          value: _vm.form.dischargingPort,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "dischargingPort", $$v)
                          },
                          expression: "form.dischargingPort"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.destinationPortCode.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "destinationPortCode" },
                      slot: "destinationPortCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.destinationPortCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.destinationPortCode.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: true,
                          "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.form.destinationPortCode || "",
                          "tag-name": "englishName",
                          no: "destinationPortCode"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.portChange(p, "destinationPort")
                          }
                        }
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.destinationPortCode
                            .writable,
                          no: "52"
                        },
                        model: {
                          value: _vm.form.destinationPort,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "destinationPort", $$v)
                          },
                          expression: "form.destinationPort"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.destinationPlace.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "destinationPlace" },
                      slot: "destinationPlace"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.destinationPlace.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.destinationPlace.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.destinationPlace.writable,
                          no: "53"
                        },
                        model: {
                          value: _vm.form.destinationPlace,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "destinationPlace", $$v)
                          },
                          expression: "form.destinationPlace"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.paymentTerm.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "paymentTerm" }, slot: "paymentTerm" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.paymentTerm.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.paymentTerm.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "54",
                          disabled: !_vm.elementDict.paymentTerm.writable,
                          "select-type": _vm.TYPE_NAMES.basic_data_PaymentTerm,
                          filterable: "",
                          "allow-create": true,
                          "default-value": _vm.form.paymentTerm
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.paymentTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.paymentPlaceBL.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "paymentPlaceBL" },
                      slot: "paymentPlaceBL"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.paymentPlaceBL.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.paymentPlaceBL.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: true,
                          value: _vm.form.paymentPlaceBL
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.freightTermHBL.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "freightTermHBL" },
                      slot: "freightTermHBL"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.freightTermHBL.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.freightTermHBL.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { disabled: true, value: _vm.job.freightTermHBL }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.blNumber.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "blNumber" }, slot: "blNumber" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.blNumber.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.blNumber.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { disabled: true, value: _vm.form.blNumber }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.signPlaceBL.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "signPlaceBL" }, slot: "signPlaceBL" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.signPlaceBL.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.signPlaceBL.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { disabled: true, value: _vm.form.signPlaceBL }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.signDateBL.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "signDateBL" }, slot: "signDateBL" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.signDateBL.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.signDateBL.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled: !_vm.elementDict.signDateBL.writable,
                          no: "55",
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.form.signDateBL,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "signDateBL", $$v)
                          },
                          expression: "form.signDateBL"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.remarks.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "remarks" }, slot: "remarks" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.remarks.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.remarks.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.remarks.writable,
                          no: "56",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.BlRemarks"),
                              _vm.form.remarks,
                              function(val) {
                                _vm.form.remarks = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "remarks", $$v)
                          },
                          expression: "form.remarks"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.alsoNotify.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "alsoNotify" }, slot: "alsoNotify" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.alsoNotify.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.alsoNotify.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-rich-textarea", {
                        staticStyle: { height: "110px" },
                        attrs: {
                          no: "57",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.alsoNotify.writable,
                          "text-chars": 0,
                          "wrap-symbol": "r",
                          "auto-uppercase": "",
                          "auto-half-word": ""
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              "ALSO NOTIFY",
                              _vm.form.alsoNotify,
                              function(val) {
                                _vm.form.alsoNotify = val.toUpperCase()
                              },
                              _vm.notUppercaseShipperConsigneNotify,
                              {
                                warningCount: 45,
                                autoHalfWord: true,
                                autoUppercase: true
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.alsoNotify,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "alsoNotify", $$v)
                          },
                          expression: "form.alsoNotify"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.job.typeVirtualHbl ===
                        _vm.VirtualBillType.NORMAL_VIRTUAL_BILL_TYPE.code,
                      expression:
                        "job.typeVirtualHbl===VirtualBillType.NORMAL_VIRTUAL_BILL_TYPE.code"
                    }
                  ],
                  staticClass: "auto-width",
                  attrs: {
                    slot: "orderBusinessAssociation",
                    "label-width": "0"
                  },
                  slot: "orderBusinessAssociation"
                },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "100%", height: "200px" },
                    attrs: {
                      no: "58",
                      "grid-options": _vm.bill.gridOptions,
                      "column-defs": _vm.bill.columnDefs,
                      "row-data": _vm.billFinalRowData
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.bill.gridApi = params.api
                      }
                    }
                  }),
                  _c("div", { staticStyle: { padding: "5px 0" } }, [
                    _c(
                      "div",
                      { staticStyle: { float: "right" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "59",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.orderBusinessAssociation
                                  .writable,
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.newSubBillHandler()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Add")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "60",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.orderBusinessAssociation
                                  .writable,
                              type: "danger"
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.delSubBillHandler()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.job.typeVirtualHbl ===
                        _vm.VirtualBillType.MERGE_VIRTUAL_BILL_TYPE.code,
                      expression:
                        "job.typeVirtualHbl===VirtualBillType.MERGE_VIRTUAL_BILL_TYPE.code"
                    }
                  ],
                  staticClass: "auto-width",
                  attrs: {
                    slot: "orderBusinessAssociation",
                    "label-width": "0"
                  },
                  slot: "orderBusinessAssociation"
                },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "100%", height: "200px" },
                    attrs: {
                      no: "66",
                      "config-module": "2023121501",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.orderBusinessAssociation.writable,
                      "grid-options": _vm.virtualMergeBill.gridOptions,
                      "column-defs": _vm.virtualMergeBill.columnDefs,
                      "row-data": _vm.virtualMergeBillFinalRowData
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.virtualMergeBill.gridApi = params.api
                      }
                    }
                  }),
                  _c("div", { staticStyle: { padding: "5px 0" } }, [
                    _c(
                      "div",
                      { staticStyle: { float: "right" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "67",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.orderBusinessAssociation
                                  .writable,
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.joinVirtualMergeBillHandler()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Join")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "68",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.orderBusinessAssociation
                                  .writable,
                              type: "danger"
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.removeVirtualMergeBillHandler()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _vm.elementDict.releaseType.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "releaseType" }, slot: "releaseType" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.releaseType.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.releaseType.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "61",
                            disabled:
                              _vm.readonly ||
                              !_vm.elementDict.releaseType.writable,
                            placeholder: _vm.readonly
                              ? ""
                              : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                            value: _vm.form.releaseType || ""
                          },
                          on: {
                            input: function(val) {
                              _vm.form.releaseType = val
                            },
                            change: function(val) {
                              _vm.pm.cmbreleaseTypeMBLChangeHandler(val)
                            }
                          }
                        },
                        _vm._l(_vm.blModeList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.name,
                              value: item.serialNumber
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.issuerBL.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "issuerBL" }, slot: "issuerBL" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.issuerBL.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.issuerBL.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        ref: "orderFormType",
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "62",
                          disabled:
                            _vm.readonly || !_vm.elementDict.issuerBL.writable,
                          "select-type":
                            _vm.TYPE_NAMES.basic_data_OrderFormType,
                          filterable: "",
                          "default-value": _vm.form.issuerBL
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.cmbissuerHBLChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.typeVirtualHbl.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "typeVirtualHbl" },
                      slot: "typeVirtualHbl"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.typeVirtualHbl.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.typeVirtualHbl.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            value: _vm.job.typeVirtualHbl || 0,
                            disabled:
                              _vm.readonly ||
                              _vm.cmbtypeHAWB2Disabled ||
                              !_vm.elementDict.typeVirtualHbl.writable,
                            no: "typeVirtualHbl",
                            clearable: false
                          },
                          on: {
                            input: function(val) {
                              _vm.pm.typeVirtualHblChangeHandler(val)
                            }
                          }
                        },
                        _vm._l(_vm.VIRTUAL_BILL_TYPES, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.chineseName, value: item.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.printParam4.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "printParam4" }, slot: "printParam4" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.printParam4.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.printParam4.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "63",
                            disabled:
                              _vm.readonly ||
                              !_vm.elementDict.printParam4.writable,
                            placeholder: _vm.readonly
                              ? ""
                              : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                            filterable: "",
                            "allow-create": ""
                          },
                          model: {
                            value: _vm.form.printParam4,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "printParam4", $$v)
                            },
                            expression: "form.printParam4"
                          }
                        },
                        _vm._l(_vm.pm.printParam4Type, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.label, value: item.data }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.printParam5.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "printParam5" }, slot: "printParam5" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.printParam5.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.printParam5.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "64",
                            disabled:
                              _vm.readonly ||
                              !_vm.elementDict.printParam5.writable,
                            placeholder: _vm.readonly
                              ? ""
                              : _vm.$t("CargoMsg.Cargo_PleaseSelect")
                          },
                          model: {
                            value: _vm.form.printParam5,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "printParam5", $$v)
                            },
                            expression: "form.printParam5"
                          }
                        },
                        _vm._l(_vm.pm.printParam5Type, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.label, value: item.data }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.container.viewable &&
                        _vm.job.containerLoadType === "BB",
                      expression:
                        "elementDict.container.viewable && job.containerLoadType==='BB'"
                    }
                  ],
                  attrs: { slot: "container" },
                  slot: "container"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.container.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.container.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-rich-textarea", {
                    staticStyle: { height: "110px" },
                    attrs: {
                      no: "65",
                      disabled:
                        _vm.readonly || !_vm.elementDict.container.writable,
                      "text-chars": 0,
                      "wrap-symbol": "r"
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.CNTRNOSSEALNOS"),
                          _vm.form.container,
                          function(val) {
                            _vm.form.container = val
                          },
                          true,
                          { warningCount: 45 }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.container,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "container", $$v)
                      },
                      expression: "form.container"
                    }
                  })
                ],
                1
              ),
              _vm.elementDict.lblCfrState.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "red",
                      attrs: { slot: "lblCfrState" },
                      slot: "lblCfrState"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.lblCfrState.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.lblCfrState.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        staticStyle: { flex: "1" },
                        attrs: { value: _vm.lblCfrState, disabled: true }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.billLadingIssued.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "red",
                      attrs: { slot: "billLadingIssued" },
                      slot: "billLadingIssued"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.billLadingIssued.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.billLadingIssued.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { value: _vm.billLadingIssued, disabled: true }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.billOfLadingPackingInfo.viewable
                ? _c(
                    "div",
                    {
                      staticClass: "section",
                      attrs: { slot: "billOfLadingPackingInfo" },
                      slot: "billOfLadingPackingInfo"
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("SeaExport.BillOfLadingPackingInfo"))
                        )
                      ]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isEdit,
                                  expression: "isEdit"
                                }
                              ],
                              staticStyle: { padding: "5px 0" }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "AddPackingInfo",
                                    type: "primary",
                                    disabled:
                                      !_vm.btnContainerEnable ||
                                      !_vm.elementDict.billOfLadingPackingInfo
                                        .writable
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.addContainerUsageClickHandler()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.AddPackingInfo"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "RemovePackingInfo",
                                    type: "primary",
                                    disabled:
                                      !_vm.btnContainerEnable ||
                                      !_vm.elementDict.billOfLadingPackingInfo
                                        .writable
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.removeContainerUsageClickHandler()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.RemovePackingInfo")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c("cargo-ag-grid", {
                            staticStyle: { width: "100%", height: "350px" },
                            attrs: {
                              no: "BillOfLadingPackingInfo",
                              "grid-options": _vm.container.gridOptions,
                              "column-defs": _vm.containerColumnDefs,
                              "row-data": _vm.ediContainerFinalRowData
                            },
                            on: {
                              gridReady: function(params) {
                                _vm.container.gridApi = params.api
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e()
            ],
            2
          ),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.advanceTextDialog.visible,
                title: _vm.advanceTextDialog.title,
                width: "600px",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.advanceTextDialog, "visible", $event)
                }
              }
            },
            [
              _c("cargo-rich-textarea", {
                ref: "advanceTextDialogTextarea",
                staticStyle: { height: "320px" },
                attrs: {
                  "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
                  "auto-uppercase": _vm.advanceTextDialog.isUppercase,
                  "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
                  "auto-half-word":
                    _vm.advanceTextDialog.formatObj.autoHalfWord,
                  disabled: _vm.readonly
                },
                model: {
                  value: _vm.advanceTextDialog.value,
                  callback: function($$v) {
                    _vm.$set(_vm.advanceTextDialog, "value", $$v)
                  },
                  expression: "advanceTextDialog.value"
                }
              }),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.finishAdvanceText }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.advanceTextDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("bill-address-dialog", {
            attrs: {
              visible: _vm.billAddressDialog.visible,
              job: _vm.job,
              params: _vm.billAddressDialog.params
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.billAddressDialog, "visible", $event)
              },
              callback: _vm.codeSearchCallback
            }
          }),
          _c("job-no-transcribe-dialog", {
            attrs: {
              visible: _vm.searchBillNoDialog.visible,
              params: _vm.searchBillNoDialog.params
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.searchBillNoDialog, "visible", $event)
              },
              selected: _vm.searchBillNoDialog.selectHandler
            }
          }),
          _c("transcribe-dialog", {
            attrs: { visible: _vm.transcribeDialog.visible, job: _vm.job },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.transcribeDialog, "visible", $event)
              },
              callback: _vm.transcribeCallback
            }
          }),
          _c("cargo-template-selector-dialog", {
            attrs: {
              visible: _vm.templateSelectorDialog.visible,
              ctx: _vm.templateSelectorDialog.ctx,
              category: _vm.templateSelectorDialog.category,
              data: _vm.templateSelectorDialog.data,
              context: _vm.context,
              "pre-print-callback": _vm.prePrintCallback,
              "printed-callback": _vm.printedCallback,
              "v2-check-callback": _vm.v2CheckCallback,
              "return-main-callback": _vm.returnMainCallback
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
              }
            }
          }),
          _c("add-cargo-doc-container-dialog", {
            attrs: {
              visible: _vm.cargoDocUsageSelectedDialog.visible,
              job: _vm.job,
              "doc-type": _vm.CargoDocConsts.HBL2,
              "cargo-docs": _vm.billFinalRowData,
              "page-source": "subBill"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.cargoDocUsageSelectedDialog,
                  "visible",
                  $event
                )
              },
              callback: _vm.cargoDocUsageSelectedDialog.callback
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }